import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e2b15de&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4e2b15de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b15de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e2b15de')) {
      api.createRecord('4e2b15de', component.options)
    } else {
      api.reload('4e2b15de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e2b15de&scoped=true&", function () {
      api.rerender('4e2b15de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/region/regionAgent/index.vue"
export default component.exports